import { LitElement, html, css } from 'lit-element'
import FirebaseLoginUiClass from './firebase-login-ui'

import PixelDrawUiClass from './pixeldraw-ui'
import GanStyleUiClass from './ganstyle-ui'
//函數


//

class MainClass extends LitElement {
    constructor () {
      super()
      window.fetch('config.json').then(res => res.json()).then(config => {
        this.defaultIndex = config.defaultIndex
        this.defaultBackend = config.defaultBackend
        this.urlColumn = config.urlColumn || 'url'
        this.init()
      })
    }
  
    init () {
      
        
        
        
    }

    static get properties () {
        return {
          service: { type: Object }
          
        }
    }

    static get styles () {
      return css`
      
      `
    }
    
  render () {
      return html``
  }
  
}

//初始化
// customElements.define('main-ui', MainClass);
customElements.define('firebase-login-ui', FirebaseLoginUiClass);
customElements.define('pixeldraw-ui', PixelDrawUiClass);
customElements.define('ganstyle-ui', GanStyleUiClass);



if(document.getElementById("index-page")) 
{ 
  
  var yourLoginStateEle=document.getElementById('yourLoginState');
  var yourSubscribeStateEle=document.getElementById('yourSubscribeState');
  var userSettingBtnEle=document.getElementById('userSettingBtn');
  var painter007BtnEle=document.getElementById('painter007');


  //
  userSettingBtnEle.addEventListener('click',()=>{
    if(yourLoginStateEle.value=='0'){
      alert('please log in first')
    }else{
      // document.getElementsByClassName('userSettingA').href='user-setting.html';
      window.location.replace('https://'+window.location.host+'/user-setting.html') 
    }
  });
  //
  painter007BtnEle.addEventListener('click',()=>{
    if(yourLoginStateEle.value=='0'){
      alert('please log in first')
    }else{
      // document.getElementsByClassName('userSettingA').href='user-setting.html';
      window.open('https://painter007.web.app') 
    }
  });
  
}





